export default __webpack_public_path__ + "static/media/blue-logo.3848cb48.png";